// extracted by mini-css-extract-plugin
export default {"container":"Image_container__mNuXA","placeholderContainer":"Image_placeholderContainer__AuTO2"};